import { render, staticRenderFns } from "./EditTaskName.vue?vue&type=template&id=028ea752&scoped=true&"
import script from "./EditTaskName.vue?vue&type=script&lang=js&"
export * from "./EditTaskName.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskName.vue?vue&type=style&index=0&id=028ea752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ea752",
  null
  
)

export default component.exports